function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.46 4.007a.5.5 0 01.5-.5h.75a.75.75 0 000-1.5h-.75a2 2 0 00-2 2v9a2 2 0 002 2h10a2 2 0 002-2v-9a2 2 0 00-2-2h-.75a.75.75 0 000 1.5h.75a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-.46v-5.5a2 2 0 00-2-2h-5a2 2 0 00-2 2v5.5h-.54a.5.5 0 01-.5-.5v-9zm8.54 9.5H5v-.804h6v.804zm0-2.304H5v-.972h6v.972zM5 8.007v.724h6v-.724a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.3 2.993l.595.458-.595-.458c-.15.196-.229.438-.222.684l.022.785-.74-.263a1.073 1.073 0 00-.72 0l-.74.263.022-.785a1.073 1.073 0 00-.222-.684l-.59.455.59-.455-.479-.622.754-.222c.236-.07.442-.22.581-.423L8 1.078l.444.648.619-.424-.619.424c.14.204.345.353.582.423l.753.222-.479.622z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgIconSuperstore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgIconSuperstore;